const defaultUrlConfig = {
  defaultModuleName: 'default',
  defaultTabName: 'default',
  defaultSubTabName: 'default',
  homeTabName: 'home',
} as const;

export default defaultUrlConfig;
